import { Box } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { BriaImageProps } from "../../../../../components/common/Galleries/BriaImage.tsx";
import ScrollableGallery from "../../../../../components/common/Galleries/ScrollableGallery.tsx";
import Selectable from "../../../../../components/common/Selectable/Selectable.tsx";
import { useAppStore } from "../../../../../hooks/useStores.tsx";
import { PlaygroundImage } from "../../../../../models/image-to-image.ts";
import PlaygroundImageOverlay from "../../../../Playground/Images/Overlay/PlaygroundImageOverlay.tsx";
import styles from "./ProjectUploadedImages.module.scss";

const ProjectUploadedImages = () => {
	const { playgroundStore } = useAppStore();
	const { projectsStore } = playgroundStore;
	const [openFullScreen, setOpenFullScreen] = useState(false);
	const resultsRef = useRef<HTMLDivElement>(null);
	const { project_id } = useParams();

	useEffect(() => {
		getImages();
		return () => {
			projectsStore.handleSelectImagesElements([], "uploadedImages");
		};
	}, [project_id]);

	const getImages = () => {
		if (project_id) {
			projectsStore.getUploadedImages(project_id, 1);
		}
	};

	// const handleFavoriteImage = async (image: PlaygroundImage) => {
	// 	await projectsStore.handleAddImageToFavorite(image, !image?.is_favorite);
	// 	getImages();
	// };

	// const handleDeleteImage = async (image: PlaygroundImage) => {
	// 	await projectsStore.handleDeleteImage(image.id);
	// 	getImages();
	// };

	return (
		<Box className={clsx(styles.uploadORSaveGalleryWrapper, "galleryWrapper")}>
			<Selectable
				selectoRef={playgroundStore.selectoRef as any}
				selectableTargets={[".selectableImage"]}
				onSelect={(e) => projectsStore.handleSelectImagesElements(e.selected, "uploadedImages")}
				innerScrollRef={resultsRef}
				className={styles.selectable}
				type={"multi"}
			>
				<ScrollableGallery
					images={projectsStore.uploadedImages.items.map(
						(image) =>
							({
								...image,
								ImageOverlay: <PlaygroundImageOverlay {...{ image }} hideAiEditorButton />,
								displayOverlay: "customHover",
								selectable: true,
								htmlJsonData: image.id,
								fullScreenProps: {
									fileName: image.file?.name.split(".")[0],
								},
								downloadProps: { fileName: playgroundStore.getFileName(image) },
							}) as BriaImageProps & PlaygroundImage,
					)}
					fullScreenProps={{
						open: openFullScreen,
						onClose: () => setOpenFullScreen(false),
						displayMode: "scroll",
					}}
					className={styles.gallery}
				/>
			</Selectable>
		</Box>
	);
};

export default observer(ProjectUploadedImages);
